import React, { useState } from "react";
import "./styles/register.css";

//this is for aws server
const API_BASE_URL = "https://dizv6b75kj46r.cloudfront.net";


//this is for local server
//const API_BASE_URL = "http://localhost:5001";

// const API_BASE_URL = "http://192.168.1.42:5001";



async function postJSON(path, body) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || `Request failed (${res.status})`);
  }
  return data;
}

export default function Register() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(null); // {username, RemainingTurns}

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const emailTrim = email.trim().toLowerCase();
    if (!emailTrim) return setError("Email is required.");
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== pw2) return setError("Passwords do not match.");

    setLoading(true);
    try {
      const data = await postJSON("/register", { email: emailTrim, password: pw });
      setSuccess({ username: data.username, RemainingTurns: data.RemainingTurns });

      // optional: remember the email
      localStorage.setItem("loopen_email", emailTrim);

      // optional: redirect to login page after success
      // window.location.href = "/login";
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authPage">
      <div className="authGlow" />

      <header className="authTop">
        <div className="authBrand">
          <div className="authDot" />
          <span className="authName">Loopen</span>
          
        </div>

        {/* Optional link to login page if you have it */}
        <a className="authTopLink" href="/login">
          Sign in
        </a>
      </header>

      <main className="authWrap">
        <section className="authCard">
          {!success ? (
            <>
              <h1 className="authTitle">Create account</h1>
              <p className="authSubtitle">
                Register with your email to start using the app.
              </p>

              <form className="authForm" onSubmit={onSubmit}>
                <label className="authLabel">
                  Email
                  <input
                    className="authInput"
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </label>

                <label className="authLabel">
                  Password
                  <input
                    className="authInput"
                    type="password"
                    placeholder="At least 8 characters"
                    value={pw}
                    onChange={(e) => setPw(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </label>

                <label className="authLabel">
                  Confirm password
                  <input
                    className="authInput"
                    type="password"
                    placeholder="Re-enter password"
                    value={pw2}
                    onChange={(e) => setPw2(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </label>

                {error ? <div className="authError">{error}</div> : null}

                <button className="authBtn" type="submit" disabled={loading}>
                  {loading ? "Creating…" : "Create account"}
                </button>

                <div className="authFinePrint">
                  By creating an account you agree to the terms.
                </div>
              </form>
            </>
          ) : (
            <>
              <h1 className="authTitle">Account created ✅</h1>
              <p className="authSubtitle">
                You’re registered as <span className="authMono">{success.username}</span>
              </p>

              <div className="authStats">
                <div className="authStat">
                  <div className="authStatLabel">Remaining turns</div>
                  <div className="authStatValue">{success.RemainingTurns}</div>
                </div>
              </div>

              <a className="authBtn authBtnSecondary" href="/login">
                Go to Sign in
              </a>
            </>
          )}
        </section>

        <footer className="authFooter">
          © {new Date().getFullYear()} Loopen
        </footer>
      </main>
    </div>
  );
}
